import * as _ from 'lodash';
import * as React from 'react';
import { observer } from 'mobx-react';
import { useOrgStore } from '../../../../hooks/useOrgStore';
import { FormikMultipleSelectWidget } from '../../../../widgets/inputs/FormikMultipleSelectWidget';

export interface RoleSelectWidgetProps {
  name: string;
  label: string;
  placeHolder: string;
  defaultValue?: string[];
  disabled?: boolean;
  className?: any;
}

export const RoleSelectWidget: React.FC<RoleSelectWidgetProps> = observer((props) => {
  const orgStore = useOrgStore();
  const { current_org } = orgStore;

  // Currently can only assign roles that the Editing user has
  const roleOptions = React.useMemo(() => {
    if (!current_org) {
      return [];
    }

    const {
      roles: { items: roleItems }
    } = current_org;

    return _.chain(roleItems ?? [])
      .sortBy((roleModel) => roleModel.options.role.name)
      .map((roleModel) => {
        return {
          label: roleModel.options.role.name,
          value: roleModel.id
        };
      })
      .value();
  }, [current_org?.roles.loading, current_org?.roles.items]);

  return <FormikMultipleSelectWidget {...props} options={roleOptions} />;
});
